import * as React from 'react';
export const bankislamSvg = React.forwardRef(function bankislamSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#C70773',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.527 23.039c-6.247-.286-11.161-3.793-10.976-7.834.184-4.04 5.398-7.085 11.645-6.8.245.012.487.029.727.05-.477-.064-.963-.11-1.458-.137C9.819 7.953 4.24 11.106 4.008 15.36c-.234 4.255 4.964 8 11.61 8.366 6.313.347 11.661-2.481 12.382-6.412-.97 3.49-5.794 5.983-11.473 5.724Z',
      fill: '#fff',
    }),
  );
});
bankislamSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bankislam = {
  category: 'brand',
  colorable: false,
  name: 'bankislam',
  svg: bankislamSvg,
};
